<template>
    <svg class="LoadingSpinner" viewBox="0 0 17 17" xmlns="http://www.w3.org/2000/svg" fill="none">
        <mask id="prefix__a" :fill="fillColor">
            <path d="M8.333 0a8.333 8.333 0 103.063.583l-.643 1.628a6.584 6.584 0 11-2.42-.461V0z" />
        </mask>
        <path
            d="M8.333 0a8.333 8.333 0 103.063.583l-.643 1.628a6.584 6.584 0 11-2.42-.461V0z"
            stroke="#000"
            stroke-opacity=".2"
            stroke-width="4.167"
            mask="url(#prefix__a)"
        />
    </svg>
</template>

<script>
export default {
    props: {
        fillColor: {
            type: String,
            default: "#fff",
        },
    },
    data() {
        return {};
    },
    // computed: {
    //     circleNotchIconUrl() {
    //         return `${process.env.VUE_APP_OSS_ORIGIN}EMP/Backend/svg/PublicTabs/CircleNotch.svg`;
    //     },
    // },
};
</script>

<style scoped>
.LoadingSpinner {
    animation: 0.75s linear 0s infinite normal none running loading-spin;
}

@keyframes loading-spin {
    100% {
        transform: rotate(360deg);
    }
}
</style>
